import { render, staticRenderFns } from "./EditLabelsDialog.vue?vue&type=template&id=014900f8&scoped=true&"
import script from "./EditLabelsDialog.vue?vue&type=script&lang=js&"
export * from "./EditLabelsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditLabelsDialog.vue?vue&type=style&index=0&id=014900f8&lang=scss&scoped=true&"
import style1 from "./EditLabelsDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014900f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VList,VListItem,VTextField})
